import { GridSkeleton } from "@/components/Skeletons";

export default function AssetsSkeleton() {
  return <GridSkeleton columns={6} rows={6} />;
}
